"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.PoiNameCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var pois = state.informationLists.pois;
  return {
    pois: pois
  };
};

exports.mapStateToProps = mapStateToProps;

var PoiNameCell = function PoiNameCell(_ref) {
  var waypoint = _ref.waypoint,
      pois = _ref.pois;
  var _waypoint$poiId = waypoint.poiId,
      poiId = _waypoint$poiId === void 0 ? null : _waypoint$poiId,
      _waypoint$poiName = waypoint.poiName,
      poiName = _waypoint$poiName === void 0 ? '' : _waypoint$poiName;
  var poi = {
    name: poiName,
    category: 'Default',
    categoryName: ''
  };
  var matchPoi = pois.find(function (p) {
    return p.id === poiId;
  });

  if (matchPoi) {
    poi = {
      name: matchPoi.name,
      category: matchPoi.category.icon,
      categoryName: matchPoi.category.name
    };
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "poi-name"
  }, poi.name);
};

exports.PoiNameCell = PoiNameCell;
PoiNameCell.propTypes = {
  waypoint: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    poiId: _propTypes["default"].number,
    poiName: _propTypes["default"].string,
    radius: _propTypes["default"].number,
    geometry: _propTypes["default"].shape({}),
    address: _propTypes["default"].shape({}),
    poiLongitude: _propTypes["default"].string,
    poiLatitude: _propTypes["default"].string
  }),
  pois: _propTypes["default"].instanceOf(Object)
};
PoiNameCell.defaultProps = {
  waypoint: {
    id: '',
    poiId: null,
    poiName: '',
    radius: 0,
    geometry: {},
    address: {}
  },
  pois: []
};
var ConnectedPoiNameCell = (0, _reactRedux.connect)(mapStateToProps)(PoiNameCell);

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConnectedPoiNameCell, {
    waypoint: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].shape({
    poiId: _propTypes["default"].number,
    poiName: _propTypes["default"].string
  })
};
renderer.defaultProps = {
  cellData: {
    poiId: null,
    poiName: ''
  }
};
var _default = renderer;
exports["default"] = _default;